// This should be kept up to date with the orochi value
export const mergeMessageMaxSizeBytes = 131071;
